import { EventPlanAndOptions } from 'store/Events/types';
import { GuestData } from '../services';

export const useCurrentPlan = (
  data: Pick<GuestData, 'plan'>,
  plansAndOptions: EventPlanAndOptions | null,
) => plansAndOptions?.plans.find(({ id }) => +data.plan === +id);
